import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import "./global.css";
import "./theme/colors.css";
import { ColorModeProvider } from "./theme/ColorModeProvider";
import { applyColorMode, applySpooky, readCookiePreference, readHostMode, readHostSpooky, resolveColorMode } from "./theme/colorMode";
import { initPostHog } from "./posthog";

initPostHog();

// Before the first render, so the sidebar does not flash light for dark users.
const initialColorMode = readHostMode() || resolveColorMode(readCookiePreference() || "light");
applyColorMode(initialColorMode);
applySpooky(initialColorMode === "dark" && readHostSpooky());

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <ColorModeProvider>
            <App />
        </ColorModeProvider>
    </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
